module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/up-arrow-bc611e634ed24d4090a27a1ecde26bc4.svg";